import { claimPaymentsService } from "@/services/claimPayment-api.service";

const prop_val_id = 'id'

const SET_ITEMS = 'setItems'
const SET_BUCKET_ITEMS_SEARCH_CRITERIA = 'setBucketItemsSearchCriteria'
const SET_BUCKET_ITEMS = 'setBucketItems'
const SET_BUCKET_ITEMS_PAGINATION = 'setBucketItemsPagination'
const UPDATE_ITEM = 'updateItem'

const state = () => ({
    items: [],
    bucketItemsSearchCriteria: null,
    bucketItems: [],
    bucketItemsPagination: null,
});

const getters = {
    getItems: state => state.items,
    getItemByIndex: idx => state => {
        if (state.items && state.items.length > 0 && idx > -1) {
            state.items[idx]
        }
    },
    getBucketItemsSearchCriteria: state => state.bucketItemsSearchCriteria,
    getBucketItems: state => state.bucketItems,
    getBucketItemsPagination: state => state.bucketItemsPagination,
    //getBucketItemsSearchInputs: state => state.bucketItemsSearchInputs
};

const actions = {
    loadItems({ commit }, payload) {
        return new Promise((resolve, reject) => {
            claimPaymentService
                .getItems()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(SET_ITEMS, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    authoriseable({ commit }, payload) {
        return new Promise((resolve, reject) => {
            claimPaymentsService
                .authoriseable(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        console.log('-d: ', apiResponse)
                        //if (apiResponse) {
                        //    //commit(UPDATE_ITEM, apiResponse.data)
                        //}
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    authorise({ commit }, payload) {
        return new Promise((resolve, reject) => {
            claimPaymentsService
                .authorise(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            commit(UPDATE_ITEM, apiResponse.data)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    loadBucketItems({ commit }, payload) {
        return new Promise((resolve, reject) => {
            claimPaymentsService
                .getAll(payload)
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            //console.log('-r: ', apiResponse)
                            commit(SET_BUCKET_ITEMS, apiResponse.data)
                            commit(SET_BUCKET_ITEMS_PAGINATION, apiResponse.pagination)
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    setBucketItemsSearchCriteria({ commit }, payload) {
        commit(SET_BUCKET_ITEMS_SEARCH_CRITERIA, payload)
    }
};

const mutations = {
    [SET_ITEMS](state, payload) {
        state.items = payload
    },
    [SET_BUCKET_ITEMS](state, payload) {
        state.bucketItems = payload
    },
    [SET_BUCKET_ITEMS_PAGINATION](state, payload) {
        state.bucketItemsPagination = payload
    },
    [SET_BUCKET_ITEMS_SEARCH_CRITERIA](state, payload) {
        state.bucketItemsSearchCriteria = payload
    },
    [UPDATE_ITEM](state, itm) {
        if (itm && itm.hasOwnProperty(prop_val_id)) {
            const id = itm[prop_val_id]
            const idx = state.items.findIndex(o => o.id == id)
            if (idx >= 0) {
                state.items.splice(idx, 1, itm)
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}